import {AfterViewInit, Component,  OnDestroy, Input, OnInit} from '@angular/core';
import {StreamsService}  from "../../services/streams.service";
 import {PanelVisibilityService} from '../../services/panel-visibility.service'
import {StreamProject, StreamAccessKey} from "../../interfaces";
import { ClipboardService } from 'ngx-clipboard'
import { NbGlobalPosition, NbDialogService, NbToastrService, NbComponentStatus } from '@nebular/theme';

 import {AuthService}  from "../../services/auth.service";
  import {visibilityPanelAnimation} from '../../classes/visibility-panel.animation'

@Component({
  selector: 'app-stream-sale-control',
  templateUrl: './stream-sale-control.component.html',
  styleUrls: ['./stream-sale-control.component.scss'],
  animations: [visibilityPanelAnimation]
})
export class StreamSaleControlComponent implements OnInit, OnDestroy{


   
  @Input() stream: StreamProject
  @Input() keysComponent: any


  price: number = 0
 subscribeSetSale$:any = null
subscribeSetPrice$:any = null
loading:boolean = false
saleOn:boolean = false


   constructor(
    public streamsService: StreamsService,
    private _clipboardService: ClipboardService,
    private toastrService: NbToastrService,
    public authService : AuthService,
    private dialogService: NbDialogService,
    public panelVisibility: PanelVisibilityService
    ){
  }
 

  
 priceChange(){

	if(this.price === this.stream.price){return}
	if(this.price <1){
		
      this.toastrService.show('','Некоректна ціна',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })

		this.price = this.stream.price
		return
	}



		this.setPrice(this.price)
 
	
 }
 

 toggleSaleOn(){
	if(this.saleOn){
          this.setSale(true)
	}else{
          this.setSale(false)
	}
 }


  setSale(sale){
    
    this.loading = true

	if( this.subscribeSetSale$){
      this.subscribeSetSale$.unsubscribe()
     }
    this.subscribeSetSale$ = this.streamsService.updateSaleMode(this.stream._id, sale).subscribe((stream: StreamProject)=>{
  
      this.stream.accessLevel = stream.accessLevel
            this.stream.saleMode = stream.saleMode
		this.saleOn = stream.saleMode
      this.keysComponent.keysOn = this.stream.accessLevel === 1
      this.loading = false
    },(error)=>{
      this.loading = false
      // The server decides whether this content may be sold at all - it refuses
      // while the bank has not finished onboarding the author. Its sentence says
      // which half of the wait is theirs, so it is shown as-is; a generic "server
      // error" would send them to support over something that is simply not ready
      // yet. The switch goes back to what is actually stored, because a toggle left
      // sitting in a position the server rejected is a lie the author would act on.
      this.saleOn = this.stream.saleMode === true
  		this.showToast((error && error.error && error.error.message) || 'Сталася помилка сервера', 'danger')
   /*   this.toastrService.show('','Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          }) */
    })
  }


	setPrice(price){
	    

		    if(this.authService.priceLimit && price !==  this.authService.priceLimit){

		this.showToast(`Не можна змінювати ціну в безкоштовному тарифі`, 'danger')
		return false
		}


	    this.loading = true

		if( this.subscribeSetPrice$){
	      this.subscribeSetPrice$.unsubscribe()
	     }

	    this.subscribeSetPrice$ = this.streamsService.updatePrice(this.stream._id, price).subscribe((stream: StreamProject)=>{
	  
	      this.stream.price = stream.price 
	     this.price = stream.price 

	 	/* this.toastrService.show('','Цена сохранена',{
			status: 'success',
			icon:'',
			position: <NbGlobalPosition>'bottom-right'
			  }) */
		this.showToast('Ціна збережена', 'success')
	      this.loading = false

	    },(error)=>{
	      this.loading = false
	  
		this.showToast('Сталася помилка сервера', 'danger')
	  /*    this.toastrService.show('','Сталася помилка сервера',{
		status: 'danger',
		icon:'',
		position: <NbGlobalPosition>'bottom-right'
		  })*/
	    })


	  }


 showToast(text, status = 'primary'){

  this.toastrService.show('',text,{
    status: <NbComponentStatus>status,
    icon: '',
    position: <NbGlobalPosition>'bottom-end'
      })
 } 


  ngOnInit() {

	this.price = this.stream.price
		this.saleOn = this.stream.saleMode

  }


   ngOnDestroy() {
    if( this.subscribeSetSale$){
      this.subscribeSetSale$.unsubscribe()
     }
    if( this.subscribeSetPrice$){
	      this.subscribeSetPrice$.unsubscribe()
    }
   }
 

 

  
}
